import React, { lazy } from "react";
import Loadable from "../components/Loadable";
// import { authRoles } from "../auth/authRoles";
import { routeCheck } from "app/data/roles";

// DASHBOARD ROUTES
const Blank = Loadable(lazy(() => import('app/views/dashboard/Home')));

//GUEST NAVIGATION PATHS
const dashboardPaths = routeCheck(
      [ 
         { path: "/dashboard", element: <Blank/> }
      ], 
      false //true: all routes are permited | false (default) all routes are validated
)

export default dashboardPaths ;